import React from 'react';

interface ClockIconProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

const ClockIcon = ({ width = 16, height = 16, fill }: ClockIconProps) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3180_80264)">
      <path d="M8.00065 4.0026V8.0026L10.6673 9.33594M14.6673 8.0026C14.6673 11.6845 11.6825 14.6693 8.00065 14.6693C4.31875 14.6693 1.33398 11.6845 1.33398 8.0026C1.33398 4.32071 4.31875 1.33594 8.00065 1.33594C11.6825 1.33594 14.6673 4.32071 14.6673 8.0026Z"
        stroke={fill || "black"}
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_3180_80264">
        <rect width="16" height="16" fill={fill || "white"} />
      </clipPath>
    </defs>
  </svg>
);

export default ClockIcon;
